import styled from 'styled-components';
import { Search } from '@styled-icons/boxicons-regular/Search';

export const Container = styled.div`
  margin: 0;
  display: flex;
  flex-direction: column;
  padding-bottom: 0.5rem;
  padding: 0;
  /* width: 103%;
  margin-left: -2%; */

  .search-items-content {
    width: 47rem;
    padding: 0 1.5rem;

    background-color: #ffffff;
    margin-top: 8px;
    width: 100%;

    h4 {
      color: ${({ theme }) => theme.colors.grayDark};
      font-weight: 600;
      font-size: 1.5rem;
    }
  }

  & > header > span {
    font-family: ${({ theme }) => theme.fonts.workSans};
    color: ${({ theme }) => theme.colors.grayDark4};
    font-size: 0.875rem;
  }

  .search-items-content_header {
    padding-top: 32px;

    h3 {
      font-family: 'Source Sans Pro';
      line-height: 32px;
      font-weight: 600;
      font-size: 24px;
      color: #495961;
    }
  }
`;

export const SearchItemInputContainer = styled.div`
  margin-top: 1rem;
  position: relative;
  display: flex;
  align-items: center;

  & > div {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    min-height: 2rem;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      padding: 0;
    }

    &.loading {
      background-color: ${({ theme }) => theme.colors.gray1};
    }

    &:focus-within {
      border-color: ${({ theme }) => theme.colors.lightBlue};
    }

    & > input {
      border: none;
      outline: none;
      padding-bottom: 0.05rem;
      flex-grow: 1;

      &:placeholder-shown {
        font-style: italic;
        padding-left: 0.25rem;
        font-size: 0.75rem;
        @media (min-width: ${({ theme }) => theme.breakpoints.mobileL}) {
          font-size: 0.875rem;
        }
      }

      &:disabled {
        background-color: ${({ theme }) => theme.colors.gray1};
      }
    }

    & > .search-tag {
      background: ${({ theme }) => theme.colors.white2};
      border: 1px solid ${({ theme }) => theme.colors.white3};
      font-size: 0.875rem;

      max-width: 90%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      @media (min-width: ${({ theme }) => theme.breakpoints.mobileL}) {
        max-width: 100%;
      }
    }
  }

  & > div.search-items-button {
    display: flex;
    width: 25%;
    border: none !important;
    padding: 1.2rem 0 0 0 !important;
    margin-left: 1.5rem;

    & > button {
      border: none !important;
      width: 100%;
    }
  }
`;

export const SearchIcon = styled(Search)`
  width: 1.2rem;
`;

export const ContainerChipsAdded = styled.div`
  font-size: 0.875rem;
  margin: 1rem 0rem;
  font-family: ${({ theme }) => theme.fonts.workSans};
  color: ${({ theme }) => theme.colors.grayDark3};
`;

// export const TitleHeader = styled.h4`
//   font-size: 24px !important;
//   color: #495961;
//   font-size: 24px;
//   font-weight: 600;
// `;

export const DivSearchField = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 1.5rem;

  .hefesto-textfield__input.hide-border-bottom {
    padding: 16px;
  }

  .hefesto-textfield__input {
    padding-left: 16px;
  }

  .hefesto-textfield__left-icon {
    display: none;
  }
  .hefesto-textfield__right-icon {
    display: none;
  }
`;

export const DivWrapperTable = styled.div`
  padding: 16px 0 17px;
  margin-top: 24px;
  background-color: #efefef;

  & > div {
    padding: 0 24px;
  }

  .hefesto-pagination.hefesto-pagination__container {
    .hefesto-pagination__select {
      width: 142px !important;
    }

    .hefesto-pagination__text {
      margin-left: 32px;
      font-size: 16px;
      font-weight: 400;
      font-family: 'Work Sans', sans-serif;
      color: #000000;
    }

    .MuiPagination-root.MuiPagination-outlined.css-1oj2twp-MuiPagination-root {
      .MuiPagination-ul.css-wjh20t-MuiPagination-ul {
        .hefesto-pagination__item {
          width: 24px;
        }
      }
    }
  }
`;

export const DivWrapperMessageChooseProduct = styled.div`
  margin-top: 1.5rem;
`;
